<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>Bildirim Detayları Ekranı</h1>
          </div>
  
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">Bildirim Detayları</a></li>
          </ul>
        </div>
        <div class="row form-margin">
          <div class="col-md-12 tex-center d-flex align-items-center flex-column">
            <div class="tile">
              <h3 class="tile-title" style="text-align:center">Bildirim Detayları</h3>
              <div class="tile-body">
                <form>
                  <div class="form-group">
                    <label class="control-label">Başlık:</label>
                    <label class="form-control">{{ result.title }}</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">İçerik:</label>
                      <p class="form-control">{{ result.content }}</p>
                  </div>
                  <!-- <div class="form-group">
                    <label class="control-label">İçerik:</label>
                      <p class="form-control">{{ result.date }}</p>
                  </div> -->
                  <!-- <div class="form-group">
                    <label class="control-label">İçerik:</label>
                      <p class="form-control">{{ result.status }}</p>
                  </div> -->
                  <div class="form-group">
                    <label class="control-label">Kullanıcı Adı:</label>
                      <p class="form-control">{{ result2.name  + " " +result2.surname }}</p>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Görev Hatırlatma Tarihi:</label>
                    <label class="form-control">{{ result.date }}</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">İşlem Durumu:</label>
                    <label style="background-color: #94e594;" v-if="result.status == 0 && result.statustwo == 1" class="form-control">İŞLEM DEVAM EDİYOR</label>
                    <label style="background-color: #ff9191;" v-if="result.status == 0 && result.statustwo == 0" class="form-control">İŞLEME BAŞLANMADI</label>
                    <label style="background-color: #94e594;" v-if="result.status == 1 && result.statustwo == 1" class="form-control">İŞLEM TAMAMLANDI</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Kayıt Tarihi:</label>
                    <label class="form-control">{{ result.reg_date }}</label>
                  </div>
                  <button v-if="result.user_id == userida && result.status == 0 && result.statustwo == 1" @click="createNotice()" type="button" class="btn btn-success">TAMAMLANDI</button>
                  <button v-if="result.status == 1" @click="updateNotice()" type="button" class="btn btn-warning">GERİ YÜKLE</button>
                  <button v-if="result.user_id == userida && result.status == 0 && result.statustwo != 1 "@click="updateProcess()" type="button" class="btn btn-warning">İŞLEME AL</button>
                  <button  v-if="result.status == 1 && result.statustwo == 1" @click="deleteNotice()" type="button" class="btn btn-danger">NOTU SİL</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        result: [],
        userida: "",
        result2: [],
        id: this.$route.query.id,
        adminid : "",
      };
    },
    mounted: function() {
    this.adminid =localStorage.getItem("id"),
    this.userida =localStorage.getItem("id"),
    window.scrollTo(0, 0);
    var datas = {
      noticeId: this.id,
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
    };

    let dataUrl = store.state.base_url + "AslanSahalar/getDetailSahaNote.php?key=123";
    return axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
      this.result = response.data.data;
      this.result2 = response.data.dataUser;
      //console.log(this.result2)
    });
  },
  methods:{
  
    deleteNotice: function() {
      var url = store.state.base_url + "AslanSahalar/deleteNotice.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        noticeId: this.id,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.dataDelete == true) {
            this.$swal({
              text: "Not Başarıyla Silindi!",
              icon: "success",
              closeOnClickOutside: true,
            });
           // setTimeout(function() {location.reload()},1250);
           this.$router.push("notifications");
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    createNotice: function() {
      var url = store.state.base_url + "AslanSahalar/updateNotice.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        noticeId: this.id,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Not Başarıyla Kaydedildi!",
              icon: "success",
              closeOnClickOutside: true,
            });
           // setTimeout(function() {location.reload()},1250);
           this.$router.push("notifications");
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    updateNotice: function() {
      var url = store.state.base_url + "AslanSahalar/changeNotice.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        noticeId: this.id,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Veri Başarıyla Geri Yüklendi!",
              icon: "success",
              closeOnClickOutside: true,
            });
           // setTimeout(function() {location.reload()},1250);
           this.$router.push("notifications");
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    updateProcess: function() {
      var url = store.state.base_url + "AslanSahalar/updateProcess.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        noticeId: this.id,
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Veri Başarıyla İşleme Alındı!",
              icon: "success",
              closeOnClickOutside: true,
            });
           // setTimeout(function() {location.reload()},1250);
           this.$router.push("notifications");
          }

          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
  },
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/NotesDetailSaha.vue